/* import __COLOCATED_TEMPLATE__ from './step-response-envelope.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import SpecificationResult from 'filter-wizard/models/results/specification';

interface StepResponseEnvelopeArgs {
  geometry: { width: number; height: number };
  model: SpecificationResult;
  figureName: string;
  showHelp?: (title: string, message: string, msgparams?: Record<string, unknown>) => void;
}

export default class StepResponseEnvelopeAnnotation extends Component<StepResponseEnvelopeArgs> {
  get xpos(): number {
    return this.args.geometry.width - 20;
  }

  get ypos(): number {
    return this.args.geometry.height - 20;
  }

  showStepResponseHelp(): void {
    const title = 'help.comp-tolerance.step-response.why-no-envelope.title';
    const message = 'help.comp-tolerance.step-response.why-no-envelope.message';
    if (this.args.showHelp) {
      this.args.showHelp(title, message);
    }
  }

  @action helpEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      this.showStepResponseHelp();
    }
  }

  @action helpClick(/*event*/): void {
    this.showStepResponseHelp();
  }
}
